import React from "react";

interface VariationOptionLabelProps {
  uniqueCounts: { name: string; count: number | undefined }[];
  numberOfUniqueOptions: number;
  wrapperClass: string;
  overrideMap: { [key: string]: string };
  shouldDisplayOptionText: boolean;
  optionTextWrapperClass: string;
}

const VariationOptionLabel: React.FC<VariationOptionLabelProps> = ({
  uniqueCounts,
  numberOfUniqueOptions,
  wrapperClass,
  overrideMap,
  shouldDisplayOptionText,
  optionTextWrapperClass,
}) => {
  const shouldAppendS = (name: string) => {
    if (overrideMap[name]) return false;
    return !name.endsWith("s");
  };

  const esExceptions: Record<string, string> = {
    Finish: "Finishes",
    // add more here if needed
  };

  const formatName = (name: string) => {
    if (overrideMap[name]) return overrideMap[name];
    if (esExceptions[name]) return esExceptions[name];

    return shouldAppendS(name) ? `${name}s` : name;
  };

  return (
    <>
      {shouldDisplayOptionText ? (
        <span className={optionTextWrapperClass} data-testid="option-text">
          {numberOfUniqueOptions}{" "}
          {numberOfUniqueOptions > 1 ? "Options" : "Option"}
        </span>
      ) : (
        uniqueCounts.map(({ name, count }) => (
          <span
            key={`${name}_${count}`}
            className={wrapperClass}
            data-testid="option-text"
          >
            {`${count} ${formatName(name)}`}
          </span>
        ))
      )}
    </>
  );
};

export default React.memo(VariationOptionLabel);
